import { Component, h, Host, Prop, State, Watch } from '@stencil/core';

import wcShared from '@web-components/shared';

@Component({
  tag: 'module-avatar-component',
  styleUrl: 'main-avatar.scss',
  shadow: true,
})
export class ModuleAvatar {
  @Prop() readonly name: string = '';

  @Prop({ mutable: true }) accountId: number | null = null;
  @Prop() readonly account_id: number | null = null;

  @Prop() readonly fontSize: number = 14;
  @Prop() readonly font_size: number = 14;

  @Prop() readonly logo: string | null = null;
  @Prop() readonly size: number = 30;

  @State() fullName: string;
  @State() firstLetter: string;
  @State() secondLetter: string;

  @State() initials: string;

  private infomaniakColors = [
    '#7974B4',
    '#3990BB',
    '#00A1B9',
    '#30abff',
    '#029688',
    '#3CB572',
    '#FFC300',
    '#ED2C6E',
    '#D9283A',
  ];

  componentWillLoad() {
    this.initials = this.getInitials(this.name).toUpperCase();
  }

  componentDidLoad() {
    wcShared.displayComponent('avatar');
  }

  private getInitials(name: string): string {
    if (!Boolean(name)) {
      return '';
    }

    // remove all non-letter character from avatarName
    // see https://stackoverflow.com/a/26900132/8037302
    const avatarNameAlphaNum = name.replace(/[^A-Za-zÀ-ÖØ-öø-ÿ0-9 ]/g, '');

    if (avatarNameAlphaNum.length <= 2) {
      return avatarNameAlphaNum || '';
    }

    let parts: string[];
    let nameParts: string[] = [];

    // parse firstname lastname
    if (/ /.test(avatarNameAlphaNum)) {
      nameParts = avatarNameAlphaNum.split(' ');
    }

    // parse email
    else if ((parts = avatarNameAlphaNum.match(/^(.+?@)/))) {
      nameParts = parts[0].split('.');
    }

    // fallback to 2 first letters
    else {
      nameParts = avatarNameAlphaNum.slice(0, 2).split('');
    }

    const initials = nameParts.map((namePart) => namePart.charAt(0));
    return initials[0] + initials[initials.length - 1];
  }

  private getColor(name: string, id = 0) {
    return this.infomaniakColors[(this.hashCode(name) + id) % 8];
  }

  private hashCode(s: string) {
    return Math.abs(
      s
        .replace(/[^a-zA-Z ]+/, '')
        ?.split('')
        .reduce(function (a, b) {
          a = (a << 5) - a + b.charCodeAt(0);
          return a & a;
        }, 0),
    );
  }

  @Watch('name')
  watchName(newValue: string) {
    this.initials = this.getInitials(newValue);
  }

  @Watch('accountId')
  @Watch('account_id')
  watchFirstLetter(newValue: number) {
    this.accountId = newValue;
  }

  render() {
    return (
      <Host>
        <div class="module-avatar">
          {Boolean(this.logo) ? (
            <div class="module-avatar__logo">
              <img
                style={{
                  width: this.size + 'px',
                  height: this.size + 'px',
                }}
                src={this.logo}
                alt={this.fullName}
              />
            </div>
          ) : (
            <span
              class="module-avatar__initial"
              style={{
                width: this.size + 'px',
                height: this.size + 'px',
                'font-size': this.fontSize + 'px',
                'background-color': this.getColor(this.name, this.accountId),
              }}
            >
              {this.initials}
            </span>
          )}
        </div>
      </Host>
    );
  }
}
